document.addEventListener( 'DOMContentLoaded', () => {
  wrapImageWithFigure( '.mythos-potal-featur-block' );
} );

function wrapImageWithFigure( selector ) {
  const block = document.querySelector( selector );
    
  if ( !block ) return;

  const image = block.querySelector( 'img' );

  if ( !image || image.closest( 'figure' ) ) return;

  const figure = document.createElement( 'figure' );

  image.parentNode.insertBefore( figure, image );
  figure.appendChild( image );
}